export const classicUrl = {
  Local: "http://localhost:52428/", //change when needed
  Prod: "https://pendeltag.stockholmstag.sj.se",
  Test: "https://test-pendeltag.stockholmstag.sj.se",
  Dev: "https://dev-pendeltag.stockholmstag.sj.se",
};
